export const APP_OPENSIDEBAR = "OPEN_SIDE_BAR";
export const APP_UPDATEBREADCRUMB = "UPDATE_BREADCRUMB";
export const APP_FIREBASEUSER = "SET_FIREBASE_USER";
export const APP_PWASYNCINPROGRESS = "SET_PWASYNCPROGRESS";
export const APP_PWASYNCSTATUS = "SET_PWASYNCSTATUS";
export const APP_PWAEVENTSALL = "SET_PWAEVENTSALL";
export const APP_PWAINSTALLPROMPT = "SET_PWAINSTALLPROMPT";
